import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/query-persist-client-core";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import App from "./App.tsx";
import "./index.css";

const CACHE_VERSION = "v1";
const ONE_DAY_MS = 1000 * 60 * 60 * 24;

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			refetchOnWindowFocus: false,
			// Static CMS content — never refetch within a session
			gcTime: ONE_DAY_MS,
		},
	},
});

persistQueryClient({
	queryClient,
	persister: createSyncStoragePersister({
		storage: window.localStorage,
		key: `gaiabirth-query-cache-${CACHE_VERSION}`,
	}),
	maxAge: ONE_DAY_MS,
	// Only persist CMS queries — keeps localStorage lean
	dehydrateOptions: {
		shouldDehydrateQuery: (query) =>
			query.queryKey[0] === "pages" ||
			query.queryKey[0] === "faqs" ||
			query.queryKey[0] === "settings",
	},
});

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</React.StrictMode>,
);
